import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import RequisitionFilter from "./RequisitionFilter.vue";
import { ref } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { useRequisitionStore } from "@/stores/management/requisition";
import { toast } from "vue-sonner";
import { formatDateTime, getBadgeClassStatusRequisition, getBadgeClassUrgencyRequisition, hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApprovalRequisition',
  setup(__props) {

const headers: Header[] = [
  { text: "DATE", value: "date" },
  { text: "PIC ONBOARD", value: "pic_onboard" },
  { text: "STATUS", value: "requisition_status" },
  { text: "REF NO", value: "ref_no" },
  { text: "PORT", value: "port_name" },
  { text: "CATEGORY", value: "category_name" },
  { text: "GROUP CATEGORY", value: "group_category_name" },
  { text: "PRIORITY", value: "priority" },
  { text: "ACTIONS", value: "action" },
];

const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listRequisition = ref<any>([]);
const isLoading = ref(false);
const storeRequisition = useRequisitionStore();

const loadDataRequisition = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await storeRequisition.dispatchGetListApproval(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listRequisition.value = await storeRequisition.requisitions.items;
    page.value = await storeRequisition.requisitions.page;
    limit.value = await storeRequisition.requisitions.pageSize;
    totalItems.value = await storeRequisition.requisitions.total;
    isLoading.value = false;
  }
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataRequisition();
};

const handleEdit = (requisition: any) => {
  router.push("/management/requisition/" + requisition);
};

const handleDetail = (requisition: any) => {
  router.push("/management/requisition/detail/" + requisition);
};

const handleAddItem = (requisition: any) => {
  router.push("/management/requisition/add/" + requisition);
};

const handleDelete = async (requisition: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${requisition.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await storeRequisition.dispatchDelete(
          requisition.id
        );
        if (success) {
          toast.error("Your requisition has been deleted");
          loadDataRequisition();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};
loadDataRequisition();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "List Approval Requisition")
      ], -1)),
      _createVNode(RequisitionFilter, {
        onSearchByQuery: loadDataRequisition,
        statusFilter: false
      }),
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createBlock(_unref(EasyDataTable), {
              key: 1,
              headers: headers,
              items: listRequisition.value,
              "show-index": "",
              "server-options": {
            page: page.value,
            rowsPerPage: limit.value,
          },
              "server-items-length": totalItems.value,
              "onUpdate:serverOptions": handleServerOptionsUpdate,
              "buttons-pagination": ""
            }, {
              "item-date": _withCtx((props) => [
                _createTextVNode(_toDisplayString(_unref(formatDateTime)(props.created_at)), 1)
              ]),
              "item-requisition_status": _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_unref(getBadgeClassStatusRequisition)(props.requisition_status))
                }, _toDisplayString(props.requisition_status), 3)
              ]),
              "item-priority": _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(_unref(getBadgeClassUrgencyRequisition)(props.priority))
                }, _toDisplayString(props.priority), 3)
              ]),
              "item-action": _withCtx((props) => [
                _createElementVNode("div", _hoisted_4, [
                  (props.requisition_status.toLocaleLowerCase() == 'draft')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-info btn-sm text-white",
                        onClick: ($event: any) => (handleEdit(props.id))
                      }, " Edit ", 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm text-white",
                    onClick: ($event: any) => (handleDetail(props.id))
                  }, " View ", 8, _hoisted_6),
                  (props.requisition_status.toLocaleLowerCase() == 'draft')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-success btn-sm text-white",
                        onClick: ($event: any) => (handleAddItem(props.id))
                      }, " Item ", 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (_unref(hasAccess)('requisition-delete'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "btn btn-danger btn-sm",
                        onClick: ($event: any) => (handleDelete(props))
                      }, " Delete ", 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["items", "server-options", "server-items-length"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})